<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <breadcrumb :links="breadcrumb"></breadcrumb>
  <div class="page">
    <div class="page-header p-3">
      <h1>Trung tâm trợ giúp</h1>
    </div>
    <div class="page-body px-3">
      <div class="mb-3">
        <div class="mb-3">
          <b>Mục đích:</b>
          <div>
            Quản lý những CPD quảng cáo hiển thị trên trang của đối tác (trang nội bộ, trang thuê bên ngoài
            ví dụ: như những trang tin tức về bóng đá..)
          </div>
        </div>
        <div class="mb-3">
          <b>Nghiệp vụ đặt CPD:</b>
          <div>- MKT sẽ liên hệ với trang đối tác để lấy (nội bộ) hoặc mua (bên ngoài), sau đó xem kích thước của vị trí
            mua đặt quảng cáo. </div>
          <div>- MKT sẽ liên hệ design để thiết kế banner đúng kích thước theo quy định của đối tác</div>
          <div>- Lên Tool CPD tạo CPD, generate file (tool thực hiện), sau đó cung cấp cho đối tác về cách nhúng quảng cáo
            CPD của mình trên trang đối tác.</div>
        </div>
        <div class="mb-3">
          <b>Về Tool CPD:</b>
          <div>- Tool CPD cho phép tạo CPD theo từng user (account đăng nhập), mỗi người sẽ chịu trách nhiệm với đối tác
            quảng cáo của mình.</div>
          <div>- Mỗi tag trên CPD tương ứng là 1 site (tag user tự đặc), nên đặt 1 site là 1 tag cho dễ quản lí</div>
          <div>- Key position tương ứng với vị trí do bên đối tác cung cấp</div>
          <div>
            <div>- Thời gian CPD được hiển thị trên trang đối tác, có thể để trống nếu không có thời gian xác định</div>
            <div>+ Ngày bắt đầu ~ kêt thúc: ngày bắt đầu</div>
            <div>+ Thời gian đặc biệt from ~ to: thời gian start & kết thúc hiển thị trong ngày</div>
          </div>
          <div>- Brand & Key liên kết: 2 mục này được lấy từ tool domain chặn, từ tool domain sẽ lấy được url liên kết
            quảng cáo (khi click vào quảng cáo nó sẽ mở trang này lên). Tool này một số brand có sẵn liên kết, chọn brand
            nó sẽ trả về danh sách key để chọn.</div>
          <div>- CPD có 2 loại ảnh ở PC / Mobile (có select chọn thiết bị khi tạo CPD), ít nhất phải có 1 ảnh PC hoặc
            Mobile (tùy vào trang đối tác có vị trí quảng cáo đó ở thiết bị PC / Mobile không mà mình up cả 2 ảnh)</div>
          <div>- Cùng 1 vị trí có thể tạo nhiều CPD, cùng 1 đối tác có thể có nhiều user tạo CPD (độc lập)</div>
        </div>
      </div>
      <doc-menu class="mt-5"></doc-menu>
  </div>
</div>
</template>